import { ISlot } from '../interfaces/slot.interfaces'
import { slots } from '../mockdata/slots'

const initialState = slots as ISlot[]

export const slotsReducer = (state = initialState): ISlot[] => state
